import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

/* Dashboards */
import Dashboard from '../pages/dashboard/dashboard';

import eSIM from '../pages/esim/esim.vue'
import uploadImei from '../pages/esim/imei.vue'

import newActivationRequest from '../pages/activation/new_request.vue'
import viewActivationRequest from '../pages/activation/view_request.vue'

import newWhitelistRequest from '../pages/whitelist/new_request.vue'
import viewWhitelistRequest from '../pages/whitelist/view_request.vue'
import viewWhitelisting from '../pages/whitelist/view_whitelisting.vue'

import simDataUsage from '../pages/diagnosis/data_usage.vue'

import SimReport from '../pages/reports/sim_report.vue'
import ActivationReport from '../pages/reports/activation_report.vue'
import WhitelistReport from '../pages/reports/whitelist_report.vue'

import Settings from '../pages/settings/settings.vue'


//Auth
import login from '../auth/login';
import Register from '../auth/register';


const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: Dashboard,
        meta: {
          title: ' Dashboard',
        }
      },

      {
        path: "esim",
        name: "esim",
        component: eSIM,
        meta: {
          title: "eSIM Management",
        },
      },
      {
        path: "upload_imei",
        name: "upload_imei",
        component: uploadImei,
        meta: {
          title: "Upload IMEI",
        },
      },

      {
        path: "new_activation",
        name: "new_activation",
        component: newActivationRequest,
        meta: {
          title: "New Activation Request",
        },
      },
      {
        path: "view_activation",
        name: "view_activation",
        component: viewActivationRequest,
        meta: {
          title: "View Activation Request",
        },
      },

      {
        path: "new_whitelist",
        name: "new_whitelist",
        component: newWhitelistRequest,
        meta: {
          title: "New Whitelist Request",
        },
      },
      {
        path: "view_whitelist_request",
        name: "view_whitelist_request",
        component: viewWhitelistRequest,
        meta: {
          title: "View Whitelist Request",
        },
      },
      {
        path: "view_whitelisting",
        name: "view_whitelisting",
        component: viewWhitelisting,
        meta: {
          title: "View Whitelisting",
        },
      },

      {
        path: "data_usage",
        name: "data_usage",
        component: simDataUsage,
        meta: {
          title: "Data Usage",
        },
      },

      {
        path: "settings",
        name: "settings",
        component: Settings,
        meta: {
          title: "Settings",
        },
      },

      {
        path: "sim_report",
        name: "sim_report",
        component: SimReport,
        meta: {
          title: "Sim Report",
        },
      },

      {
        path: "activation_report",
        name: "activation_report",
        component: ActivationReport,
        meta: {
          title: "Activation Report",
        },
      },

      {
        path: "whitelist_report",
        name: "whitelist_report",
        component: WhitelistReport,
        meta: {
          title: "Whitelist Report",
        },
      },
    ]
  },
  {
    path: '/',
    component: Body,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'Trazio Networks Dashboard',
        }
      },
    ]
  },


  {
    path: '/',
    children: [
      {
        path: 'login',
        name: 'login',
        component: login,
        meta: {
          title: ' Login | Trazio Networks',
        }
      },
      {
        path: 'register',
        name: 'register 1',
        component: Register,
        meta: {
          title: ' Register | Trazio Networks',
        }
      }
    ]
  },

]
const router = createRouter({
  history: createWebHistory('trazio-networks'),
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.meta.title)
    document.title = to.meta.title;
  const path = ['/login', '/register'];
  if (path.includes(to.path) || localStorage.getItem('trazio')) {
    return next();
  }
  next('/login');
});
export default router